<template>
	<div>
		<a-row justify="space-around" :gutter="8">
			<a-col v-for="(plan, i) in plansState.plans" :key="plan.id" :span="12">
				<a-card class="plan-col">
					<a-row>
						<a-col
							><h4>
								<strong>£{{ priceWithoutVAT(plan.price, plan.id) }}</strong> user/{{ plan.chargeCycle === 1?`month` :`year`}}
							</h4></a-col
						>
					</a-row>
					<a-row class="mb-3 mt-3">
						<a-col>
							<h5>
								<strong>{{ plan.name }}</strong>
							</h5>
						</a-col>
					</a-row>
					<a-row class="mb-3 mt-3">
						<a-col>
							<span>{{ plan.subtitle }}</span>
						</a-col>
					</a-row>
					<a-row class="mb-3 mt-3">
						<a-col>
							<div v-html="plan.description" style="text-align: left"></div>
						</a-col>
					</a-row>
					<a-row v-if="selectedIndex == i" class="mb-3 mt-3">
						<a-row class="mb-3 mt-3">
							No. of subscribers <a-input-number id="inputNumber" v-model="subscriptionQuantity" :min="1" :max="1000"/>
						</a-row>
						<a-row class="mt-3">
							Total Amount <strong>£{{GetFinalAmount(subscriptionQuantity *  priceWithoutVAT(plan.price, plan.id)) }}</strong>
						</a-row>
					</a-row>
					<a-row class="mt-4">
						<a-col>
							<a-button
								:type="selectedIndex == i ? 'primary' : ''"
								@click="select(i)"
							>
								Select
							</a-button>
						</a-col>
					</a-row>
				</a-card>
			</a-col>
		</a-row>
		<a-row v-if="invalid">
			<p class="error-message">* {{ errorMessages.noPlanSelected }}</p>
		</a-row>
	</div>
</template>
<script>
const ERROR_MESSAGES = {
	noPlanSelected: "Please select a plan in order to proceed to payments.",
};

import { plansState, plansMutations } from "../../../Store/store.js";

export default {
	async mounted() {
		await this.plansMutations.getPlans();
		if(this.invitation?.subscriptionPlanId) {
			this.plansState.plans = [this.plansState.plans.find(p => p.id == this.invitation?.subscriptionPlanId)];
		}
	},
	props: {
		company: {
			type: Object,
			required: true,
		},
		invitation: Object,
		events: { type: Object, required: true },
		validate: Boolean,
	},
	data() {
		return {
			rules: {
				"subscription.id": [
					{ required: true, message: "Please select a plan", trigger: "blur" },
				],
				"subscription.quantity": [
					{
						required: true,
						message: "Please enter number of users",
						trigger: "blur",
					},
					{
						min: 1,
						message: "Number of users must be more than zero",
						trigger: "blur",
					}
				],
			},
			selectedIndex: null,
			invalid: false,
			errorMessages: ERROR_MESSAGES,
			plansState: plansState,
			plansMutations: plansMutations,
			subscriptionQuantity: 1
		};
	},
	methods: {
		select(index) {
			this.selectedIndex = index;
			this.company.subscription.subscriptionPlanId =
				this.plansState.plans[this.selectedIndex].id;
			this.company.subscription.subscriptionQuantity = this.subscriptionQuantity;
		},
		priceWithoutVAT(price, planId) {
			if (this.invitation?.subscriptionPlanId && planId == this.invitation?.subscriptionPlanId) {
				price = this.invitation?.overridedPrice
					? this.invitation?.overridedPrice
					: price;
			}
			return (price / 1.2).toFixed(2);
		},
		GetFinalAmount(amount){
			return amount.toFixed(2);
		}
	},
	watch: {
		validate(newVal) {
			if (newVal) {
				if (this.selectedIndex != null) {
					this.invalid = false;
					this.$emit(this.events.moveNext, {
						source: "SubscriptionDetails",
						isValid: true,
					});
				} else {
					this.invalid = true;
				}
			}
		},
		subscriptionQuantity(val){
			this.company.subscription.subscriptionQuantity = val;
		}
	},
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/_variables";
.plan-col {
	background-color: $grey;
	border-radius: 7px;
	min-height: 200px;
	width: 100%;
}
.hyperlink {
	color: $glsblue !important;
}
.error-message {
	color: red;
}
</style>
